import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function VolumesSection() {
  const volumes = [{
    title: 'VOLUME 1',
    subtitle: 'Alimentazione Infantile Sana',
    desc: 'Scopri come nutrire correttamente il tuo bambino.',
    features: ['Nutrizione infantile spiegata in modo semplice', 'Quantità consigliate per età', 'Errori più comuni', 'Guida agli alimenti ultra-processati', 'Tabelle e schemi pratici']
  }, {
    title: 'VOLUME 2',
    subtitle: 'Colazioni e Merende Sane',
    desc: 'Inizia la giornata con energia.',
    features: ['Oltre 70 ricette', 'Muffin', 'Pancake', 'Smoothie', 'Yogurt bowl', 'Merende scolastiche']
  }, {
    title: 'VOLUME 3',
    subtitle: 'Pranzi e Cene per Tutta la Famiglia',
    desc: 'Pasti completi senza stress.',
    features: ['Oltre 120 ricette', 'Piatti completi', 'Idee veloci', 'Ricette approvate dai bambini', 'Versioni economiche']
  }, {
    title: 'VOLUME 4',
    subtitle: 'Menù Settimanali Pronti',
    desc: 'Organizzazione perfetta.',
    features: ['Settimane complete già organizzate', 'Liste della spesa incluse', 'Menù stagionali', 'Menù economici', 'Menù per bambini selettivi']
  }, {
    title: 'VOLUME 5',
    subtitle: 'Meal Prep Familiare',
    desc: 'Risparmia tempo prezioso.',
    features: ['Organizza una settimana in meno di 2 ore', 'Congelamento intelligente', 'Checklist', 'Planner stampabili']
  }, {
    title: 'VOLUME 6',
    subtitle: 'Lunchbox Perfette per la Scuola',
    desc: 'Pasti fuori casa sani e pratici.',
    features: ['50 lunchbox complete', 'Idee pratiche', 'Lunchbox sportive', 'Lunchbox economiche', 'Calendario scolastico incluso']
  }];
  return <section className="bg-gray-50 py-20 px-4 border-t border-gray-200" data-id="element-212">
      <div className="max-w-6xl mx-auto" data-id="element-213">
        <div className="text-center mb-16" data-id="element-214">
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#1f2e10] mb-4" data-id="element-215">
            COSA RICEVERAI
          </h2>
          <p className="text-xl text-gray-600" data-id="element-216">
            Il sistema completo in 6 volumi pratici
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-217">
          {volumes.map((vol, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-lg flex flex-col" data-id="element-218">
              <div className="bg-[#1f2e10] p-6 text-center" data-id="element-219">
                <span className="inline-block bg-[#c4f000] text-[#1f2e10] text-xs font-black px-3 py-1 rounded-full mb-3 tracking-widest" data-id="element-220">
                  {vol.title}
                </span>
                <h3 className="text-xl font-bold text-white leading-tight" data-id="element-221">
                  {vol.subtitle}
                </h3>
              </div>
              <div className="p-6 flex-grow" data-id="element-222">
                <p className="text-gray-600 mb-6 text-sm italic" data-id="element-223">{vol.desc}</p>
                <ul className="space-y-3" data-id="element-224">
                  {vol.features.map((feature, fIdx) => <li key={fIdx} className="flex items-start gap-2" data-id="element-225">
                      <CheckCircle2 size={18} className="text-green-500 mt-0.5 flex-shrink-0" data-id="element-226" />
                      <span className="text-gray-700 text-sm font-medium" data-id="element-227">
                        {feature}
                      </span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}